'use client';

import {
  GridItem,
  LayoutGrid,
  TypographyV3 as Typography,
} from '@jouzen/ecom-components';
import { ComponentPropsWithoutRef, PropsWithChildren, ReactNode } from 'react';

export interface SectionProps
  extends Omit<ComponentPropsWithoutRef<'div'>, 'title'> {
  readonly title: ReactNode | string;
  readonly className?: string;
  readonly border?: boolean;
}

const Section = ({
  title,
  children,
  className,
  border,
  ...sectionProps
}: PropsWithChildren<SectionProps>) => {
  const isTitleString = typeof title === 'string';

  return (
    <section className={className} data-testid="section" {...sectionProps}>
      <LayoutGrid rowGap={24} className="w-full">
        <GridItem colEnd={{ sm: 'main', md: 8 }} colStart={{ sm: 'main' }}>
          {isTitleString ? (
            <Typography Element="h2" variant="h5">
              {title}
            </Typography>
          ) : (
            title
          )}
        </GridItem>

        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main', md: 9 }}>
          {children}
        </GridItem>

        {border && (
          <GridItem
            className="mb-12 mt-6"
            colStart={{ sm: 'main' }}
            colEnd={{ sm: 'main' }}
          >
            <hr className="border-gray-300" />
          </GridItem>
        )}
      </LayoutGrid>
    </section>
  );
};

export default Section;
